var cart = JSON.parse(sessionStorage.getItem('cart'))
if (!cart) {
  cart = []
}

var cartItemNum = cart.length

export default {
  cartItemNum
}



// WEBPACK FOOTER //
// ./src/utils/cart.js